<template>
  <div class="register-container">
    <div class="register-box">
      <div class="register-header">
        <h1>{{ $t('auth.register') }}</h1>
        <p>Cross-Language Collaborative Teaching Platform</p>
      </div>
      
      <a-form
        :model="registerForm"
        :rules="rules"
        @finish="handleRegister"
        class="register-form"
      >
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item name="username">
              <a-input
                v-model:value="registerForm.username"
                :placeholder="$t('auth.username')"
                size="large"
                :prefix="h(UserOutlined)"
                autocomplete="username"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="email">
              <a-input
                v-model:value="registerForm.email"
                :placeholder="$t('auth.email')"
                size="large"
                :prefix="h(MailOutlined)"
                autocomplete="email"
              />
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item name="password">
              <a-input-password
                v-model:value="registerForm.password"
                :placeholder="$t('auth.password')"
                size="large"
                :prefix="h(LockOutlined)"
                autocomplete="new-password"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="confirmPassword">
              <a-input-password
                v-model:value="registerForm.confirmPassword"
                :placeholder="$t('auth.confirmPassword')"
                size="large"
                :prefix="h(LockOutlined)"
                autocomplete="new-password"
              />
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item name="name">
              <a-input
                v-model:value="registerForm.name"
                :placeholder="$t('auth.name')"
                size="large"
                :prefix="h(IdcardOutlined)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="phone">
              <a-input
                v-model:value="registerForm.phone"
                :placeholder="$t('auth.phone')"
                size="large"
                :prefix="h(PhoneOutlined)"
              />
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item name="nationality">
              <a-select
                v-model:value="registerForm.nationality"
                :placeholder="$t('auth.selectNationality')"
                size="large"
                show-search
                @change="handleNationalityChange"
              >
                <a-select-option value="中国">{{ $t('auth.nationality.china') }}</a-select-option>
                <a-select-option value="美国">{{ $t('auth.nationality.usa') }}</a-select-option>
                <a-select-option value="英国">{{ $t('auth.nationality.uk') }}</a-select-option>
                <a-select-option value="日本">{{ $t('auth.nationality.japan') }}</a-select-option>
                <a-select-option value="韩国">{{ $t('auth.nationality.korea') }}</a-select-option>
                <a-select-option value="法国">{{ $t('auth.nationality.france') }}</a-select-option>
                <a-select-option value="德国">{{ $t('auth.nationality.germany') }}</a-select-option>
                <a-select-option value="西班牙">{{ $t('auth.nationality.spain') }}</a-select-option>
                <a-select-option value="意大利">{{ $t('auth.nationality.italy') }}</a-select-option>
                <a-select-option value="俄罗斯">{{ $t('auth.nationality.russia') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="language">
              <a-select
                v-model:value="registerForm.language"
                :placeholder="$t('auth.selectLanguage')"
                size="large"
              >
                <a-select-option value="zh">{{ $t('auth.language.chinese') }}</a-select-option>
                <a-select-option value="en">{{ $t('auth.language.english') }}</a-select-option>
                <a-select-option value="ja">{{ $t('auth.language.japanese') }}</a-select-option>
                <a-select-option value="ko">{{ $t('auth.language.korean') }}</a-select-option>
                <a-select-option value="fr">{{ $t('auth.language.french') }}</a-select-option>
                <a-select-option value="de">{{ $t('auth.language.german') }}</a-select-option>
                <a-select-option value="es">{{ $t('auth.language.spanish') }}</a-select-option>
                <a-select-option value="it">{{ $t('auth.language.italian') }}</a-select-option>
                <a-select-option value="ru">{{ $t('auth.language.russian') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item name="school">
              <a-input
                v-model:value="registerForm.school"
                :placeholder="$t('auth.school')"
                size="large"
                :prefix="h(BankOutlined)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="department">
              <a-input
                v-model:value="registerForm.department"
                :placeholder="$t('auth.department')"
                size="large"
                :prefix="h(ApartmentOutlined)"
              />
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-form-item name="agreement">
          <a-checkbox v-model:checked="registerForm.agreement">
            {{ $t('auth.agreementText') }} <a href="#" @click.prevent>{{ $t('auth.userAgreement') }}</a> {{ $t('common.and') }} <a href="#" @click.prevent>{{ $t('auth.privacyPolicy') }}</a>
          </a-checkbox>
        </a-form-item>
        
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            size="large"
            block
            :loading="loading"
          >
            {{ $t('auth.register') }}
          </a-button>
        </a-form-item>
        
        <div class="register-footer">
          {{ $t('auth.hasAccount') }} <router-link to="/login">{{ $t('auth.loginNow') }}</router-link>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, h, computed } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
import { 
  UserOutlined, 
  LockOutlined, 
  MailOutlined, 
  IdcardOutlined,
  PhoneOutlined,
  BankOutlined,
  ApartmentOutlined
} from '@ant-design/icons-vue'
import { createUser, type UserCreateRequest } from '@/modules/user/api'

const router = useRouter()
const { t } = useI18n()
const loading = ref(false)

const registerForm = reactive({
  username: '',
  email: '',
  password: '',
  confirmPassword: '',
  name: '',
  phone: '',
  nationality: '',
  language: '',
  school: '',
  department: '',
  agreement: false
})

const rules = computed(() => ({
  username: [
    { required: true, message: t('auth.pleaseEnterUsername'), trigger: 'blur' },
    { min: 3, max: 50, message: t('auth.usernameLength'), trigger: 'blur' }
  ],
  email: [
    { required: true, message: t('auth.pleaseEnterEmail'), trigger: 'blur' },
    { type: 'email', message: t('auth.invalidEmail'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: t('auth.pleaseEnterPassword'), trigger: 'blur' },
    { min: 6, message: t('auth.passwordMinLength'), trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: t('auth.pleaseConfirmPassword'), trigger: 'blur' },
    {
      validator: (_rule: any, value: string) => {
        if (value !== registerForm.password) {
          return Promise.reject(t('auth.passwordMismatch'))
        }
        return Promise.resolve()
      },
      trigger: 'blur'
    }
  ],
  name: [
    { required: true, message: t('auth.pleaseEnterName'), trigger: 'blur' },
    { max: 100, message: t('auth.nameMaxLength'), trigger: 'blur' }
  ],
  nationality: [
    { required: true, message: t('auth.pleaseSelectNationality'), trigger: 'change' }
  ],
  language: [
    { required: true, message: t('auth.pleaseSelectLanguage'), trigger: 'change' }
  ],
  agreement: [
    {
      validator: (_rule: any, value: boolean) => {
        if (!value) {
          return Promise.reject(t('auth.pleaseAgreeToTerms'))
        }
        return Promise.resolve()
      },
      trigger: 'change'
    }
  ]
}))

// 国籍-语种映射
const nationalityLanguageMap: Record<string, string> = {
  '中国': 'zh',
  '美国': 'en',
  '英国': 'en',
  '日本': 'ja',
  '韩国': 'ko',
  '法国': 'fr',
  '德国': 'de',
  '西班牙': 'es',
  '意大利': 'it',
  '俄罗斯': 'ru'
}

const handleNationalityChange = (nationality: string) => {
  if (nationality && nationalityLanguageMap[nationality]) {
    registerForm.language = nationalityLanguageMap[nationality]
  }
}

const handleRegister = async () => {
  try {
    loading.value = true
    
    const userData: UserCreateRequest = {
      username: registerForm.username,
      email: registerForm.email,
      password: registerForm.password,
      name: registerForm.name,
      nationality: registerForm.nationality,
      language: registerForm.language,
      school: registerForm.school,
      department: registerForm.department,
      phone: registerForm.phone,
      user_type: 'normal' // 注册用户默认为普通用户
    }
    
    await createUser(userData)
    
    message.success(t('auth.registerSuccess'))
    router.push('/login')
    
  } catch (error: any) {
    console.error('注册失败:', error)
  } finally {
    loading.value = false
  }
}
</script>

<style lang="less" scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.register-box {
  width: 600px;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.register-header {
  text-align: center;
  margin-bottom: 32px;
  
  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 8px;
  }
  
  p {
    color: #6b7280;
    font-size: 14px;
    margin: 0;
  }
}

.register-form {
  .ant-form-item {
    margin-bottom: 20px;
  }
}

.register-footer {
  text-align: center;
  margin-top: 16px;
  color: #6b7280;
  
  a {
    color: #1890ff;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

